/**
 * Classes sémantiques du shell institution / formateur.
 * Utilisent uniquement les variables CSS (--inst-player-*) mises à jour par
 * mergeInstitutionThemeForUiMode en mode sombre UI.
 */

export const INST_SHELL_CARD =
  'rounded-2xl border border-[color:var(--inst-player-border,#E8EDF5)] bg-[color:var(--inst-player-surface,#ffffff)] p-6 shadow-[0_8px_24px_-12px_rgba(12,28,56,0.08)]';

export const INST_SHELL_CARD_SM =
  'rounded-2xl border border-[color:var(--inst-player-border,#E8EDF5)] bg-[color:var(--inst-player-surface,#ffffff)] p-5 shadow-[0_8px_24px_-12px_rgba(12,28,56,0.08)]';

export const INST_SHELL_STAT_TILE =
  'rounded-xl border border-[color:var(--inst-player-border,#E8EDF5)] bg-[color:color-mix(in_srgb,var(--inst-player-surface,#fff)_75%,var(--inst-player-bg,#f9fafb))]';

export const INST_SHELL_MUTED = 'text-[color:var(--inst-player-text-muted,#5B6472)]';
export const INST_SHELL_TEXT = 'text-[color:var(--inst-player-text,#0C1C38)]';
export const INST_SHELL_HEADING = 'font-bold text-[color:var(--inst-player-text,#0C1C38)]';
export const INST_SHELL_ACCENT_TEXT = 'text-[color:var(--inst-player-accent,#0C1C38)]';

export const INST_SHELL_NAV_ACTIVE =
  'bg-[color:color-mix(in_srgb,var(--inst-player-accent,#5eead4)_14%,transparent)] text-[color:var(--inst-player-accent,#0C1C38)]';
export const INST_SHELL_NAV_IDLE =
  'text-[color:var(--inst-player-text-muted,#5B6472)] hover:bg-[color:color-mix(in_srgb,var(--inst-player-text,#0C1C38)_6%,transparent)] hover:text-[color:var(--inst-player-text,#0C1C38)]';
export const INST_SHELL_NAV_ICON_ACTIVE = 'text-[color:var(--inst-player-accent,#0C1C38)]';
export const INST_SHELL_NAV_INDICATOR = 'bg-[color:var(--inst-player-accent,#0C1C38)]';
export const INST_SHELL_ICON_TILE =
  'bg-[color:color-mix(in_srgb,var(--inst-player-accent,#5eead4)_18%,transparent)] text-[color:var(--inst-player-text,#0C1C38)]';

export const INST_SHELL_ALERT_AMBER = 'inst-shell-alert inst-shell-alert-amber';
export const INST_SHELL_ALERT_ROSE = 'inst-shell-alert inst-shell-alert-rose';
